import React, { useState } from "react";

import ItemPickerNative from "../../../../private/ItemPickerNative";
import "./styles.scss";
import {PickerItemSelector, PickerProps} from "./props";

const Picker = (props: PickerProps) => {
  const { buttonOnClick, buttonText, title } = props;
  const { items } = props;

  const [state, setState] = useState({
    language: items?.language?.selected || "",
    currency: items?.currency?.selected || "",
  });

  const handleOptionChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    pickerType: string
  ) => {

    const pickerTypeLower = pickerType.toLowerCase() as keyof PickerItemSelector;

    setState({
      ...state,
      [pickerTypeLower]: e.target.value,
    });
    // items will for sure exist at this point.
    const pickerItem = items![pickerTypeLower];
    pickerItem?.onChange?.(
      e,
      pickerTypeLower
    );
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    buttonOnClick(e, state);
  };

  const newItems = {...items};
  if (props.hideCurrency && items) {
    newItems.currency = undefined;
  }

  return (
    <div className="language-currency-picker-container">
      <h3>{title}</h3>
      {newItems && Object.values(newItems).map((item) => {
        if (!item) return null;

        return (
          <ItemPickerNative
            key={item.label}
            label={item.label}
            options={item.options}
            onChange={(e) => handleOptionChange(e, item.pickerType)}
            selected={item.selected}
            pickerType={item.pickerType}
          />
        );
      })}
      <button
        className="language-currency-picker-container__picker-button-text"
        onClick={handleButtonClick}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default React.memo(Picker);
